export default (function () {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
});